<template>
<div>
  <!-- <div v-if="isLoading">
    <loading />
  </div> -->
  <div v-if="isNoResult">
    <no-result @tryAgain="tryAgain" :noResult="noResult" />
  </div>
  <div v-else class="trending_list_page">
    <div class="header" style="background-image: linear-gradient(180deg, #EEE8E1 0%, rgba(238,232,225,0.00) 100%);">
      <!-- 头部-右侧背景图 左侧title箭头 左侧说明1行或2行 -->
      <img class="right_bg" :src="header.ambientImg" />
      <div v-if="header && header.titleV2" class="header_title1" :style="{color:header.titleV2.fontColor||'rgba(0,0,0,0.8)'}">
        {{header.titleV2.content}}
        <RichText v-if="header.titleV2.icon && header.titleV2.icon !== ''"  :text="header.titleV2.icon" :style="'display:flex;align-items:center;'" />
      </div>
      <div class="header_subtitle">
        <div
        :class="['sub_item', item.isMultiLine === 1 ? 'single' : 'double']"
        v-for="(item, index) in header.subTitleV2" :key="index"
        :style="{color:item.fontColor ||'rgba(0,0,0,0.6)'}"
        >
          <!-- <RichText class="icon" v-if="item.leftIcon" :text="item.leftIcon" :style="'display:flex;align-items:center;'" /> -->
          <img v-if="item.leftIcon && item.leftIcon!==''" class="icon" :src="item.leftIcon" />
          <div class="content">{{item.content}}</div>
        </div>
      </div>
    </div>
    <div :class="['feed_container_out', showTabBar ? 'min_height' : '', types.length === 1 ? 'short_types' : '']" ref="feedRef" id="feed">
      <feed :feed="feed" :getObserverLogData="getObserverLogData" @traceShopCk="traceShopCk" />
    </div>
    <!-- 吸顶 -->
    <div :class="['tab_bar', showTabBar ? '' : 'hidden']">
      <div class="tab_title">
        <!-- <svg @click="closePage" xmlns="http://www.w3.org/2000/svg" overflow="hidden" viewBox="0 0 48 48" style="width:1em;height:1em;vertical-align:middle"><path fill-rule="nonzero" d="M33.39 4.558a1.976 1.976 0 0 0-2.684-.063l-.124.119-15.196 15.918a5.026 5.026 0 0 0-.164 6.75l.163.18 15.197 15.924c.76.796 2.017.821 2.808.056.75-.725.811-1.9.17-2.698l-.114-.13L18.249 24.69a1.005 1.005 0 0 1-.078-1.293l.079-.093L33.446 7.386a2.01 2.01 0 0 0-.056-2.828z"/></svg> -->
        <!-- <div class="title">{{$t('FoodC_STORE_sDEb_djsn' /**trending food */)}}</div> -->
      </div>
      <div class="tab_type_1"></div><!-- 单榜单单品类占位 -->
    </div>
    <!-- rules按钮 -->
    <div v-if="!showTabBar" class="rules" @click="showRules">
      <div class="name">{{$t('FoodC_shoprank_OYFZ_jaot' /** rules */)}}</div>
      <img class="rules_img" src="./img/outlined_pickup_right.png" />
    </div>
    <!-- rules -->
    <rules v-if="isShowRules" :rules="rules" @clickMask="clickMask" />
  </div>
</div>
</template>
<script>
import RichText from '@/components/RichText';
import Feed from './feed'
import Rules from './rules'
import Loading from './loading.vue'
import NoResult from './noResult.vue'
import Api from "@/api";
import { requestHelper } from "@/api/common";
import trackEvent from '@/common/js/track'
import animateScrollTo from 'animated-scroll-to';
export default {
  components: {
    RichText,
    Feed,
    Rules,
    Loading,
    NoResult
  },
  data() {
    return {
      isLoading: false,
      isNoResult: false,
      isNoResultFeed: false,
      isShowRules: false,
      fromChannel: 0, // 商卡1 榜单组件0
      topicId: 0,
      shopId: 0,
      header: {},
      rules: [],
      types: [],
      subItems: [],
      feed: [],
      ruleMap: {},
      showTabBar: false,
      occupySubItemOfAll: {},
      noResult: {
        title: '',
        subTitle: '',
      },
      traceId: '',
      scrollHeight: 0,
      cateMap: {},
      page: 0,
      count: 20,
      isError: false,
      recId: 0,
      errorNo: 0,
      errorMsg: '',
      smalldiamond_scene: 0, // 场景小金刚进入传好店8，feed流不传
    }
  },
  computed: {
  },
  async created() {
    // http://sim204.act.rlab.sim.intra.xiaojukeji.com/${locale}/topshop?nativeWebUIType=1&fromchannel=0&topicId=990009&recId=&5764607595378379432
    this.isLoading = true;
    const { topicId, fromchannel, shopId, smalldiamond_scene } = this.$route.query;
    this.fromChannel = fromchannel;
    this.topicId = topicId;
    this.shopId = shopId;
    this.smalldiamond_scene = smalldiamond_scene;
    await this.rankIndex();
  },
  mounted() {
    try {
      setTimeout(() => {
        if (this.shopId) {
          let shopDom = document.querySelector(`#id_${this.shopId}`) || null;
          let feedTop = document.querySelector('#feed').offsetTop || 0;
          // shopDom && animateScrollTo(shopDom.offsetTop + feedTop - 200);
          let tabbarHeight = (document.body.clientWidth * 160) / 750;
          shopDom && animateScrollTo(shopDom, { verticalOffset: - tabbarHeight });
        }
      }, 1200);
    } catch(e) {}
    window.addEventListener("scroll", this.onScroll);
  },
  methods: {
    getObserverLogData(shop, index) {
      var tags = [];
      shop.tags.forEach((tag) => {
        tags.push(tag.content || '');
      });
      return {
        eventId: 'sailing_c_x_top_shop_realexposure_sw',
        eventLabel: '好店店铺的实曝光',
        attrs: {
          'topic_id': this.topicId,
          'trace_id': this.traceId || '',
          'shop_id': shop.shopId || '',
          'shop_name': shop.shopName || '',
          'shop_status': shop.cShopStatus || '',
          'shop_delivery_fee':
          shop.currency || ''
              + '_' + (shop.deliveryPriceOri || 0.0).toString()
              + '_' +  (shop.deliveryPriceAct || 0.0).toString(),
          'delivery_type': shop.deliveryType || 0,
          'delivery_time': shop.deliveryTime || 0,
          'shop_discount_tag': tags.join(','),
          'page': 'specialpage',
          'index': index + 1 || 0,
          'trending_type': this.rankType || '',
          'nlp_category_id': this.cateId || '',
          'rec_id': this.recId,
          'is_free_delivery_type': shop.freeDeliveryType || 0, // 1没有免配2券包免配3新客免配
          'from': 2,
          'homepage_source': this.fromChannel,
          'module': this.topicId,
          'smalldiamond_scene': this.smalldiamond_scene
        }
      }
    },
    traceShopCk(shop, index) {
      var tags = [];
      shop.tags.forEach((tag) => {
        tags.push(tag.content || '');
      });
      trackEvent({
        eventId: 'sailing_c_x_top_shop_ck',
        eventLabel: '好店店铺的点击',
        attrs: {
          'trace_id': this.traceId || '',
          'shop_id': shop.shopId || '',
          'shop_name': shop.shopName || '',
          'shop_status': shop.cShopStatus || '',
          'shop_delivery_fee':
          shop.currency || ''
              + '_' + (shop.deliveryPriceOri || 0.0).toString()
              + '_' +  (shop.deliveryPriceAct || 0.0).toString(),
          'delivery_time': shop.deliveryTime || 0,
          'delivery_type': shop.freeDeliveryType || 0, // 1没有免配2券包免配3新客免配
          'shop_discount_tag': tags.join(','),
          'index': index + 1 || 0,
          'rec_id': this.recId || '',
          'nlp_category_id': this.cateId || '',
          'from': 2,
          'homepage_source': this.fromChannel,
          'topic_id': this.topicId,
          'page': 'specialpage',
          'module': this.topicId,
          'smalldiamond_scene': this.smalldiamond_scene
        }
      })
    },
    // rules点击
    traceRules() {
      trackEvent({
        eventId: 'sailing_c_x_top_second_detailed_rules_ck',
        eventLabel: '好店落地页按钮点击',
        attrs: {
          'rec_id': this.recId || '',
          'page_type': 0,
          // 'act_status':
          'error_code': this.errorNo,
          'error_msg': this.errorMsg,
          'scene': 903,
          'topic_id': this.topicId,
          // 'activity_id': // 活动id
          // session_id: // 场次id
          'from_channel': this.fromChannel,
          'homepage_source': this.fromChannel,
          'is_detailed_rules': this.rules && this.rules.length ? 1 : 0,
          'button_type': 1,
        }
      })
    },
    // 页面曝光
    tracePageSW() {
      trackEvent({
        eventId: 'sailing_c_x_top_second_common_sw',
        eventLabel: '好店落地页曝光',
        attrs: {
          'trace_id': this.traceId || '',
          'rec_id': this.recId || '',
          'page_type': 0,
          // 'act_status':
          'error_code': this.errorNo,
          'error_msg': this.errorMsg,
          'scene': 903,
          'topic_id': this.topicId,
          // 'activity_id': // 活动id
          // session_id: // 场次id
          'from_channel': this.fromChannel,
          'homepage_source': this.fromChannel,
          'is_detailed_rules': this.rules && this.rules.length ? 1 : 0,
          'module': this.topicId,
          'smalldiamond_scene': this.smalldiamond_scene
        }
      })
    },
    closePage() {
      this.SodaBridge('closePage');
    },
    clickMask() {
      this.isShowRules = false;
    },
    showRules() {
      this.isShowRules = true;
      this.traceRules();
    },
    async tryAgain() {
      await this.rankIndex();
    },
    hiddenTab() {
      try {
        this.SodaBridge('updateNav', {
          // sysStatusBar: 0,
          backBtn: {
            alpha: 1,
            color: '#000000'
          },
          title: {
            color: '#000000',
            alpha: 0,
            content: '',
            position: 'center' //如果是tab进入，left，否则center，left “left/center”
          },
        })
      } catch(err) {}
    },
    showTab() {
      try {
        this.SodaBridge('updateNav', {
          // sysStatusBar: 0, // 0黑色,1白色
          backBtn: {
            alpha: 1, // 透明度
            color: '#000000' // 字体颜色
          },
          title: {
            color: '#000000',
            alpha: 1,
            content: this.$t('FoodB_20230410_YNjt_xAWA' /**Didi top */),
            position: 'center' //如果是tab进入，left，否则center，left “left/center”
          },
          // rightBtns: [ // titlebar右边按钮
          //   {
          //     type: 1, // 0 图片 1 文字
          //     title: 'rules',
          //     // name: 'shareBtn',
          //     alpha: 1,
          //     currentIcon: 'https://img0.didiglobal.com/static/soda_public/do1_e8QdxjQyfzpLv2vg2ghN', // 实际图 cdn链接
          //     preloadIcon: 'https://img0.didiglobal.com/static/soda_public/do1_e8QdxjQyfzpLv2vg2ghN', // 预加载图
          //     // currentIcon: '', // 实际图 cdn链接
          //     // preloadIcon: '', // 预加载图
          //     action: 'triggerShareButtonEvent'
          //   }
          // ]
        })
      } catch(err) {}
    },
    onScroll(e) {
      // 滑动加载更多
      if (!this.$refs.feedRef) return;
      const innerHeight = this.$refs.feedRef.clientHeight;
      const outerHeight = document.documentElement.clientHeight;
      const { scrollTop } = document.documentElement;
      if (innerHeight < scrollTop + outerHeight) {
        !this.isLoading && this.rankIndex();
      }
      const feedTop = this.$refs?.feedRef?.getBoundingClientRect()?.top;
      const isShow = this.showTabBar;
      const changeShow = feedTop < 250;
      this.showTabBar = changeShow;
      if (!isShow && changeShow) {
        this.showTab();
      }
      if (isShow && !changeShow) {
        this.hiddenTab();
      }
    },
    async rankIndex() {
      this.isLoading = true;
      const params = {
        page: this.page,
        count: this.count,
        blockId: this.topicId,
        scene: ''
      }
      const res = await Api.topicIndexV4({ data: params });
      const { errno, traceId, errmsg, data: { header, distributor, feed, noResult, recId }} = res
      this.recId = recId
      this.errorNo = errno
      this.errorMsg = errmsg
      this.traceId = traceId;
      this.noResult = noResult?.compList[0].data;
      // immutable rules map
      if (this.page===0) {
        this.isNoResult = noResult;
        if (this.isNoResult) return;
        this.header = header?.data;
        this.rules = header?.data?.rules;
        header.data.rules[1].rankRules.forEach(r => {
          this.ruleMap[r.type] = r;
        });
      }
      if (errno !== 0) {
        this.isNoResult = true;
        this.noResult = {
          subTitle: errmsg
        }
        return;
      }
      this.page += 1;
      // feed
      this.feed = this.page === 0 ? feed?.compList : this.removeDuplicates(this.feed.concat(feed?.compList));
      this.isLoading = false;
      if (this.page === 1) {
        this.tracePageSW();
      }
    },
    removeDuplicates(list) {
      let res = [];
      let isExist = {};
      list.forEach(item => {
        if (!isExist[item?.data?.shopId]) {
          res.push(item);
          isExist[item?.data?.shopId] = true;
        }
      });
      return res;
    }
  },
  beforeDestroy () {}
}
</script>
<style lang="scss" scoped>
.trending_list_page {
  position: relative;
  width: 100%;
  .back_icon {
    position: absolute;
    left: 46px;
    top: 88px;
    width: 18.97px;
    height: 33.99px;
  }
  .tab_bar {
    &.hidden {
      display: none;
    }
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    background: #F5F5F5;
    opacity: 1;
    .tab_type_1 {
      margin-top: 160px;
    }
  }
  .header {
    position: absolute;
    top: 0;
    left: 0;
    .header_title1 {
      position: absolute;
      top: 202px;
      left: 46px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: DiDiSans-Pro-Bold;
      font-size: 80px;
      letter-spacing: 0;
    }
    .header_subtitle {
      position: absolute;
      top: 317px;
      left: 48px;
      display: flex;
      flex-direction: column;
      font-family: DiDiSans-Pro-Regular;
      font-size: 28px;
      // color: #4D4D4D;
      color: rgba(0,0,0,0.6);
      letter-spacing: 0;
      text-align: left;
      line-height: 30px;
      font-weight: 400;
      .sub_item {
        margin-bottom: 16px;
        display: flex;
        align-items: center;
        justify-content: left;
        .icon {
          width: 28px;
          height: 28px;
          margin-right: 8px;
        }
        &.single .content {
          max-width: 364px;
          overflow:hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          -o-text-overflow:ellipsis;
        }
        &.double .content {
          line-height: 50px;
          max-width: 400px;
          overflow:hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          display: -webkit-box;
          -webkit-box-orient: vertical;
        }
      }
    }
    .right_bg {
      width: 100%;
    }
  }
  .feed_container_out {
    position: absolute;
    top: 844px;
    background: #FAFAFA;
  }
}
.rules {
  position: absolute;
  top: 138px;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,0.49);
  border-radius: 23px 0 0 23px;
  padding: 10px 16px 10px 24px;
  .name {
    font-family: DiDiSans-Pro-Regular;
    font-size: 24px;
    color: #FFFFFF;
    letter-spacing: 0;
    font-weight: 400;
  }
  .rules_img {
    width: 20px;
    height: 20px;
    margin-left: 4px;
  }
}
</style>
